import { apiClient } from "../../base/ApiClient";

// post photographs
export const createPhotograph = async (formData) => {
  try {
    const response = await apiClient.post(`/client/photographs/`, formData);
    return response.data;
  } catch (error) {
    console.error(
      "Error in posting photographs",
      error.response?.data || error.message
    );
    throw error;
  }
};

// get photograph
export const getAllPhotographs = async (id, page) => {
  try {
    const response = await apiClient.get(
      `/client/photographs/?page=${page}&client_id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching photographs",
      error.response?.data || error.message
    );
    throw error;
  }
};

// get photograph by id for update
export const getPhotographById = async (id) => {
  const response = await apiClient.get(`/client/photographs/${id}/`);
  return response.data;
};

// update photograph

export const updatePhotograph = async (id, editData) => {
  const response = await apiClient.put(`/client/photographs/${id}/`, editData);
  return response.data;
};

// Delete photograph
export const deletePhotograph = async (id) => {
  const response = await apiClient.delete(`/client/photographs/${id}/`);
  return response.data;
};
